import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/element-ui-reset.scss' // 引入全局样式覆盖
import './styles/table-override.scss' // 引入表格样式覆盖
import locale from 'element-ui/lib/locale/lang/zh-CN'

Vue.config.productionTip = false

// 使用Element UI
Vue.use(ElementUI, { locale })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

